
const DIRECTORY_CANDIDATES_DEPARTMENTS_ROUTES = {
  path: 'directory/candidates/departments',
  name: 'candidates-departments',
  component: () => import('@/views/pages/Directories/departmentCandidates/DirectoryDepartmentCandidates.vue')
}

export default  DIRECTORY_CANDIDATES_DEPARTMENTS_ROUTES;